/// <amd-module name="Reporting/DataQuality/DataQualityWarningsComponent" />
import * as React from "react";

import { VssComponent } from "VSS/Platform/Layout";

import { Icon } from "VSSUI/Components/Icon/Icon";
import { Location } from "VSSUI/Utilities/Position";

export interface DataQualityWarningsComponentProps {
    warning: string;
}

export class DataQualityWarningsComponent extends VssComponent<DataQualityWarningsComponentProps> {
    public render(): JSX.Element {
        return (
            <Icon
                iconName="Error"
                className={"data-quality-warnings-component"}
                tooltipProps={{
                    anchorOffset: { horizontal: 8, vertical: 8 },
                    showOnFocus: true,
                    text: this.props.warning,
                    tooltipOrigin: {
                        horizontal: Location.start,
                        vertical: Location.start
                    },
                    renderContent: this.onRender
                }}
            />
        );
    }

    private onRender = () => {
        return <div className={"warning-message-container"}>{this.props.warning}</div>;
    };
}
